export default __webpack_public_path__ + "static/media/board-img-2.c66f4696.gif";